/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// === ACCOUNT ICON : masquer le cercle Shadow DOM + injecter PROFILE.svg ===
(function() {
  function patchShopifyAccount() {
    const shopifyAccount = document.querySelector('shopify-account');
    if (!shopifyAccount) return;

    // Injecter CSS dans le Shadow DOM pour masquer le cercle
    function injectShadowCSS() {
      const shadow = shopifyAccount.shadowRoot;
      if (!shadow) return;

      const style = document.createElement('style');
      style.textContent = `
        button, [part="avatar"], [part="signed-in-avatar"],
        .avatar, .shopify-account__avatar,
        [class*="avatar"], [class*="initials"], [class*="circle"] {
          display: none !important;
        }
      `;
      shadow.appendChild(style);
    }

    // Injecter l'icône custom PROFILE.svg dans le header
    function injectProfileIcon() {
      const accountItem = document.querySelector('.header__action-item--account');
      if (!accountItem) return;
      if (accountItem.querySelector('.header__custom-profile-icon')) return;

      const link = document.createElement('a');
      link.href = '/account';
      link.setAttribute('aria-label', 'Mon compte');
      link.style.cssText = 'display:block;line-height:0;';

      const img = document.createElement('img');
      img.src = 'https://cdn.shopify.com/s/files/1/0260/7913/3742/files/PROFILE.svg?v=1781390046';
      img.alt = 'Mon compte';
      img.width = 52;
      img.height = 52;
      img.className = 'header__custom-profile-icon';

      link.appendChild(img);
      accountItem.appendChild(link);
    }

    // Attendre que le Shadow DOM soit prêt
    const observer = new MutationObserver(function() {
      if (shopifyAccount.shadowRoot) {
        injectShadowCSS();
        observer.disconnect();
      }
    });

    observer.observe(shopifyAccount, { childList: true, subtree: true });

    // Tentative immédiate aussi
    if (shopifyAccount.shadowRoot) injectShadowCSS();

    // Icône custom : uniquement si connecté
    if (document.body.classList.contains('customer-logged-in')) {
      injectProfileIcon();
      // Masquer aussi le conteneur shopify-account lui-même
      shopifyAccount.style.display = 'none';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchShopifyAccount);
  } else {
    patchShopifyAccount();
  }
})();
